import { createContext, FC } from "react";
import styles from "./index.module.css";
import clsx from "clsx";

type ModalContextValue = {
  onModalClose(): void;
};

const ModalContext = createContext<ModalContextValue>({
  onModalClose: () => {}
});

type Props = {
  onDismiss(): void;
  children?: React.ReactNode;
};

const WidgetModal: FC<Props> = ({ children = null, onDismiss = () => 0 }) => {
  const style = clsx(styles["modal"]);
  return (
    <div className={style} onClick={e => e.stopPropagation()}>
      <ModalContext.Provider value={{ onModalClose: onDismiss }}>
        {children}
      </ModalContext.Provider>
    </div>
  );
};

export default WidgetModal;
export { ModalContext };
